import { render } from "./ActiveSessionList.vue?vue&type=template&id=06ba0196&scoped=true"
import script from "./ActiveSessionList.vue?vue&type=script&lang=js"
export * from "./ActiveSessionList.vue?vue&type=script&lang=js"

import "./ActiveSessionList.vue?vue&type=style&index=0&id=06ba0196&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ba0196"]])

export default __exports__